export var INITIAL_MODAL_TIMER = 15000;
export var SALON_CONFERENCE_WEBSITE_PRODUCT_TYPE = 'Salon Conference Website';
export var BASIC_ALLOWED_LEAD_SOURCE = 'ChowNow';
export var BASIC_PACKAGE_NAME = 'Basic';